/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PhoneSelect/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneHeader from 'DesignSystem/TysiaSelectOne/TysiaSelectOneHeader/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function PhoneSelect({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsRequestPayment/Content/ContactMethodSelect/PhoneSelect"
  
}) {
let contactMethodsPhonesValueData = fromData.useDataValue({ viewPath,
context: 'contact_methods',
path: 'phones',
})
let paymentsRequestPaymentSelectedPhoneValueData = fromData.useDataValue({ viewPath,
context: 'payments_request_payment',
path: 'selected_phone',
})
let paymentsRequestPaymentIsSubmittingValueData = fromData.useDataValue({ viewPath,
context: 'payments_request_payment',
path: 'isSubmitting',
})
let contactMethodsPhonesValueData1 = fromData.useDataValue({ viewPath,
context: 'contact_methods',
path: 'phones',
})
let aggregateData = fromHelpers.isDisabled(paymentsRequestPaymentIsSubmittingValueData, contactMethodsPhonesValueData1)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 onChange={onChange}
 data="contact_methods.phones"
 from={contactMethodsPhonesValueData}
 data="payments_request_payment.selected_phone"
 value={paymentsRequestPaymentSelectedPhoneValueData}
 data="payments_request_payment.isSubmitting"
 data="contact_methods.phones"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
 showPlaceholderIfDisabled={true}
 placeholder="Select phone"
 allowEmptyChoice={false}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneHeader
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneHeader`}
>
{childProps => (
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Phone"
/>
)}
</TysiaSelectOneHeader>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}